import $ from 'jquery';

$(document).ready(function() {
    if (!($('.b-exponat-inner__materials').height() > 0)) {
    	$('.b-exponat-inner__themes').addClass('no-materials');
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/lecture/exponats.js